import { Input as p, inputStyles as r } from "./Input.js";
export {
  p as Input,
  r as inputStyles
};
